import React, { useState } from "react";
import { styled } from "@mui/material/styles";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import { useRecoilValue, useResetRecoilState } from "recoil";
import ButtonCustom from "src/shared/components/buttons/ButtonCustom";
import { Check, LocationOn } from "@mui/icons-material";
import { Grid, Typography } from "@mui/material";
import { userState } from "src/store/user/userState";
import { grey } from "@mui/material/colors";
import { useTheme } from "@emotion/react";
import {
  errorsFormRegisterState,
  errorsReservationGuestState,
  errorsReservationUserState,
  valuesFormRegisterState,
  valuesFormReservationGuestState,
  valuesFormReservationUserState,
} from "src/Patient/state/atoms";
import ProfessionalName from "src/Professional/ProfessionalName";
import ProfessionalSpecialities from "src/Professional/ProfessionalSpecialities";
import ProfessionalPhoto from "src/Professional/ProfessionalPhoto";
import { useEffect } from "react";
import ModalTitleCustom from "src/shared/components/modals/ModalTitle";

import List from "@mui/material/List";
import ListItemText from "@mui/material/ListItemText";
import { useWaitList } from "./hooks/useWaitList";
import TabsWaitList from "./TabsWaitList";
import AutocompleteProfessionals from "./components/AutocompleteProfessionals";
import AutocompleteSpecialities from "./components/AutocompleteSpecialities";
import InputFechaIni from "./components/InputFechaIni";
import InputFechaFin from "./components/InputFechaFin";
import {
  errorsWaitListState,
  fechaFinWaitListState,
  fechaIniWaitListState,
  professionalWaitListState,
  specialityWaitListState,
} from "./state/atoms";

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  "& .MuiDialogContent-root": {
    padding: theme.spacing(2),
  },
  "& .MuiDialogActions-root": {
    padding: theme.spacing(1),
  },

  ".contFechaLogeado": {
    display: "flex",
    justifyContent: "space-between",
    gap: "1rem",
    paddingTop: "1rem",
    paddingBottom: "1rem",
  },

  ".contFechaNoLogeado": {
    display: "flex",
    justifyContent: "space-between",
    gap: "1rem",
    paddingTop: "1rem",
    paddingBottom: "1rem",
  },

  ".prestador": {
    marginTop: "1rem",
    marginBottom: "1rem",
    display: "flex",
    alignItems: "center",
  },

  ".formularioAcceso": {
    margin: 0,
    height: "100%",
    width: "100%",
    alignItems: "center",
  },

  [theme.breakpoints.up("xs")]: {
    ".contFechaNoLogeado": {
      padding: "1rem 0",
    },
  },

  [theme.breakpoints.up("md")]: {
    ".contFechaNoLogeado": {
      paddingRight: "1rem",
    },

    ".usuarioLogeado": {
      padding: "1rem",
    },

    ".usuarioSinLogear": {
      padding: "1rem",
    },
  },
}));

export default function ModalWaitList({ open, onClose }) {
  const resetErrorsFormGuest = useResetRecoilState(errorsReservationGuestState);
  const resetValuesFormGuest = useResetRecoilState(
    valuesFormReservationGuestState
  );
  const resetErrorsFormUser = useResetRecoilState(errorsReservationUserState);
  const resetValuesFormUser = useResetRecoilState(
    valuesFormReservationUserState
  );
  const resetValuesFormUserRegister = useResetRecoilState(
    valuesFormRegisterState
  );
  const resetErrorsFormRegister = useResetRecoilState(errorsFormRegisterState);
  const user = useRecoilValue(userState);

  const [indicacionesTexto, setTextoIndicaciones] = useState("");
  const [ocultar, setOcultar] = useState(false);

  const checkForDevice = () => window.innerWidth < 640;
  const [isMobile, setIsMobile] = useState(checkForDevice());

  let { handleClickSaveWaitList, loadingSaved, hourSelected, setHourSelected } =
    useWaitList();

  const theme = useTheme();

  const resetProfessional = useResetRecoilState(professionalWaitListState);
  const resetSpeciality = useResetRecoilState(specialityWaitListState);
  const resetFechaIni = useResetRecoilState(fechaIniWaitListState);
  const resetFechaFin = useResetRecoilState(fechaFinWaitListState);
  const resetErrorsWaitList = useResetRecoilState(errorsWaitListState);

  const handleClose = (ev, reason) => {
    if (reason && reason === "backdropClick") return;
    resetProfessional();
    resetSpeciality();
    resetFechaIni();
    resetFechaFin();
    resetErrorsWaitList();
    resetErrorsFormGuest();
    resetValuesFormGuest();
    resetErrorsFormUser();
    resetValuesFormUser();
    resetValuesFormUserRegister();
    setHourSelected(null);
    onClose();
    resetErrorsFormRegister();

    setOcultar(false);
  };

  useEffect(() => {
    return () => {
      resetErrorsFormGuest();
      resetValuesFormGuest();
      resetErrorsFormUser();
      resetValuesFormUser();
      resetValuesFormUserRegister();
      resetErrorsFormRegister();
    };
  }, []);

  //VALIDAR MOBILE O WEB
  useEffect(() => {
    const handlePageResized = () => {
      setIsMobile(checkForDevice());
    };

    if (typeof window !== "undefined") {
      window.addEventListener("resize", handlePageResized);
      window.addEventListener("orientationchange", handlePageResized);
      window.addEventListener("load", handlePageResized);
      window.addEventListener("reload", handlePageResized);
    }

    return () => {
      if (typeof window !== "undefined") {
        window.removeEventListener("resize", handlePageResized);
        window.removeEventListener("orientationchange", handlePageResized);
        window.removeEventListener("load", handlePageResized);
        window.removeEventListener("reload", handlePageResized);
      }
    };
  }, []);

  const confirmar = async () => {
    const flag = await handleClickSaveWaitList();

    if (flag) onClose();

    let texto = "";
    texto = hourSelected?.professional.indicacionesPaciente;
    texto = typeof texto === "undefined" ? "" : texto;
    if (texto.length > 0) {
      if (isMobile == true) {
        setOcultar(true);
      }
    } else {
      if (isMobile == true) {
        setOcultar(false);
      }
    }
  };

  const Indicaciones = () => {
    let texto = "";
    let myArray = [];
    let titulo = "";
    let descripcion = "";
    let myArrayDescripcion = [];

    try {
      texto = hourSelected?.professional.indicacionesPaciente;
      texto = typeof texto === "undefined" ? "" : texto;
      if (texto.length > 0) {
        myArray = texto.split(";");
        titulo = myArray[0];
        descripcion = myArray[1];
        myArrayDescripcion = descripcion.split(",");
      }
    } catch (error) {
      console.log(error);
      return (
        <>
          <Grid item xs={12} md={12} mr={0}>
            <Typography
              style={{
                fontWeight: "600",
                fontSize: 14,
                backgroundColor: "#fff9c4",
                color: "#f57f17",
                padding: "0.25rem 0.5rem",
              }}
            >
              Indicaciones
            </Typography>

            <pre
              style={{
                fontFamily: "Montserrat",
                fontSize: 12,
                backgroundColor: "#F9FAFB",
                padding: "0.25rem 0.5rem",
                overflow: "auto",
              }}
            >
              {ocultar == false ? texto : ""}
            </pre>
          </Grid>
        </>
      );
    }

    if (titulo.length > 0) {
      return (
        <>
          <Grid item xs={12} md={12} mr={2}>
            <Typography
              style={{
                fontWeight: "600",
                fontSize: 14,
                backgroundColor: "#fff9c4",
                color: "#f57f17",
                padding: "0.25rem 0.5rem",
              }}
            >
              {titulo}
            </Typography>
            <Typography
              style={{
                fontSize: 12,
                backgroundColor: "#F9FAFB",
                padding: "0.25rem 0.5rem",
              }}
            >
              <List dense={true}>
                {myArrayDescripcion.map((item, i) => (
                  <ListItemText key={i} disablePadding>
                    <ListItemText primary={`・ ${item}`} />
                  </ListItemText>
                ))}
              </List>
            </Typography>
          </Grid>
        </>
      );
    } else {
      return <></>;
    }
  };
  return (
    <div className="animate__animated animate__fadeIn">
      <BootstrapDialog
        maxWidth={user.isAuthenticated || !hourSelected ? "sm" : "lg"}
        onClose={handleClose}
        aria-labelledby="customized-dialog-title"
        open={open}
      >
        <ModalTitleCustom id="customized-dialog-title" onClose={handleClose}>
          Confirmar Inscripción Lista de Espera
        </ModalTitleCustom>

        <DialogContent>
          <Grid container>
            {hourSelected && (
              <Grid
                container
                item
                xs={12}
                md={user.isAuthenticated ? 12 : 5}
                style={{ height: "fit-content" }}
              >
                <Grid className="prestador">
                  <Grid width={64}>
                    <ProfessionalPhoto
                      width={64}
                      height={100}
                      image={hourSelected?.professional?.imagen}
                      alt={hourSelected?.professional?.ptdNombre}
                    />
                  </Grid>

                  <Grid ml={1}>
                    <ProfessionalName
                      fontSize={20}
                      nameProfessional={hourSelected?.professional.ptdNombre}
                    />
                    <ProfessionalSpecialities
                      specialities={hourSelected?.professional.especialidades}
                    />
                  </Grid>
                </Grid>
                <Indicaciones key={1} data={indicacionesTexto} />
                <Grid
                  container
                  className={
                    user.isAuthenticated
                      ? "contFechaLogeado"
                      : "contFechaNoLogeado"
                  }
                  borderBottom={`1px solid ${theme.palette.default.main}`}
                >
                  <Grid item className="sedeConfirmada" alignContent={"center"}>
                    <Typography
                      display={"flex"}
                      alignItems={"center"}
                      fontWeight={500}
                      color={theme.palette.secondary.main}
                    >
                      <LocationOn
                        style={{ color: grey[300], marginRight: 5 }}
                      />
                      {hourSelected?.professional.sede}
                    </Typography>
                  </Grid>
                </Grid>
              </Grid>
            )}
            {!user.isAuthenticated && (
              <Grid
                item
                xs={12}
                md={hourSelected ? 7 : 12}
                className="formularioAcceso"
                style={{ border: `2px solid ${theme.palette.default.main}` }}
              >
                <TabsWaitList />
              </Grid>
            )}
            {user.isAuthenticated && !hourSelected && (
              <Grid container item xs={12} md={12} gap={2}>
                <Grid item xs={12}>
                  <AutocompleteSpecialities
                    styles={{
                      width: "100%",
                    }}
                  />
                </Grid>
                <Grid item xs={12}>
                  <AutocompleteProfessionals
                    styles={{
                      width: "100%",
                    }}
                  />
                </Grid>
                <Grid item xs={12}>
                  <InputFechaIni />
                </Grid>
                <Grid item xs={12}>
                  <InputFechaFin />
                </Grid>
              </Grid>
            )}
            {user.isAuthenticated && hourSelected && (
              <Grid container spacing={2} sx={{ pt: 2 }}>
                <Grid item xs={12} sm={6}>
                  <AutocompleteSpecialities size="small" styles={{}} />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <AutocompleteProfessionals size="small" styles={{}} />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <InputFechaIni />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <InputFechaFin />
                </Grid>
              </Grid>
            )}
          </Grid>
        </DialogContent>
        <DialogActions>
          <ButtonCustom
            loading={loadingSaved}
            color="secondary"
            onClick={confirmar}
            text="CONFIRMAR INSCRIPCIÓN"
            icon={<Check />}
          />
        </DialogActions>
      </BootstrapDialog>
    </div>
  );
}
